import { stringParam } from '@blockit/web-shared/router/searchCodec';
import { ConnectorConsentPage } from '@features/connector-consent/ConnectorConsentPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/mcp/consent')({
  validateSearch: z.object({ pendingId: stringParam }),
  component: ConnectorConsentPage,
});
